// extracted by mini-css-extract-plugin
module.exports = {"WEIGHT":"600","PATH":"/app/themes/strazzanti/dist/font/crimsontext-semibold.2e4296129befff39c9af.ttf","NAME":"Crimson Text","STYLE":"normal"};